module.exports = __webpack_public_path__ + "img/translations.4964b136.png";